import { MenuSelection } from "./types";

export const MenuAnchors: { [menuSelection in MenuSelection]: string } = {
  [MenuSelection.HOURS]: "hours",
  [MenuSelection.ORDER]: "",
  [MenuSelection.CATERING]: "",
  [MenuSelection.LOCATION]: "location",
  [MenuSelection.MENU]: "",
};
